import Http from '@/api/http.js'

export default {

  index() {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/client_credits`)
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/client_credits`)
  },

  create(client_credit){
    return Http.post(`/client_credits`, {client_credit: {...client_credit}})
  },

  update(client_credit){
    return Http.put(`/client_credits/${client_credit.id}`, {
      client_credit: {...client_credit},
    });
  },

  show(id) {
    return Http.get(`/client_credits/${id}`);
  },

}
